import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCargoTypes } from 'actions/cargoes/types';
import CargoRealNamesTable from './RealNamesTable';

function RealNamesPage(props) {
    useEffect(() => {
        props.getCargoTypes();
    }, []);

    return (
        <div id='cargo-realnames' className='table-page'>
            <div className='container' style={{ width: '84rem' }}>
                <h2>real cargo names</h2>
                <CargoRealNamesTable />
            </div>
        </div>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            getCargoTypes,
        },
        dispatch,
    ),
)(RealNamesPage);



// WEBPACK FOOTER //
// ./app/components/Cargoes/RealNames/RealNamesPage.jsx